import { IApplicationState } from '../../types/redux';
import { getFilters } from './getFilters';

export function getFilterRegionId(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.regionId;
}
